function onResize(){
	
	// update window's variables
	updateResize();
	// Header functions
	// minWidth(1200, function(){}, headerResponsive());
	//if browser size is ok, do the click function
    if($(window).width() <= lg){
        isResponsive = true;
        $('.js-nav-dropdown').slideUp(0);
    }
    else{
        // if browser size is greater than expected, disallow clicking
        isResponsive = false;
        $('.js-nav-dropdown').slideDown(0);
    }
		
};

$(function(){
	$window.on('resize', function(){
		//resize only on width
		if(ww != $window.width()){
			onResize();
			asyncBg();
		}
	});
});